export const MAX_MESSAGE_LENGTH = 20000;
export const SHOW_MESSAGE_COUNT_FROM = 18000;

export const formatMessageCount = count =>
  count.toLocaleString('en-US');
